import { makeStyles } from '~/UIKit/Style';
import { PRIMARY_BLUE, GRAY_DARK_SHADE_2 } from '~/Constants/Colors.constants';
import { FONT_SIZE_SMALLISH, FONT_SIZE_MEDIUM } from '~/Constants/UI.constants';

export const MonthRangePickerStyles = makeStyles((theme) => ({
  wrapper: {
    height: '100%',
    display: 'grid',
    [theme.breakpoints.down('md')]: {
      background: GRAY_DARK_SHADE_2,
    },
  },
  inputWraper: {
    border: `1px solid ${PRIMARY_BLUE}`,
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 28,
    margin: 0,
    width: 180,
    cursor: 'pointer',
    position: 'relative',
    justifySelf: 'end',
  },
  dateFieldWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    height: '100%',
    width: '100%',
    color: PRIMARY_BLUE,
    fontFamily: 'fitogram, sans-serif',
  },
  dateField: {
    fontSize: FONT_SIZE_SMALLISH,
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    alignItems: 'center',
    '&:first-of-type': {
      position: 'relative',
      '&:after': {
        content: '""',
        background: PRIMARY_BLUE,
        position: 'absolute',
        width: 1,
        height: '50%',
        right: 0,
        top: '25%',
      },
    },
  },
  iconWrapper: {
    color: PRIMARY_BLUE,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingRight: 5,
    paddingLeft: 5,
    borderLeft: `1px solid ${PRIMARY_BLUE}`,
    '& .MuiSvgIcon-root': {
      fontSize: FONT_SIZE_MEDIUM,
    },
  },
  calendarWrapper: {
    minHeight: 'initial',
    maxHeight: 'initial',
    maxWidth: 'initial',
    minWidth: 'initial',
    marginTop: '0.5rem',
  },
  button: {
    justifySelf: 'end',
    margin: '15px 25px',
  },
}));
